import { useContext, useEffect } from "react";
import { Link } from "react-router-dom";
import { AuthContext } from "../../context/authContext";
import { useNavigate } from "react-router-dom";
import "./logout.scss";

const Logout = ({setAuth}) => {
  const navigate = useNavigate();
  const { logout } = useContext(AuthContext);

  useEffect(() => {
    logout(setAuth);
    navigate('/'); 
  });


  return (
    <div className="logout">
      <div className="card">
      <h1>Logging out...</h1>
      <p>If you are not being redirected to the Login Page, click <Link to="/login">Here</Link></p>
      </div>
    </div>
  );
};

export default Logout;
